





import {Component, Prop, Watch} from "vue-property-decorator"
import Vue from "vue"
import {ActiveProvide} from "@/support/reactive"


@Component({})
export default class Provider2 extends Vue {
    @ActiveProvide('jds.test.provide2') var2 = '';
    @Prop() toInject!: string;

    @Watch('toInject', {immediate: true})
    syncProvide() {
        this.var2 = this.toInject;
    }
}
